// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__JaN1G","default":"style_default__Bv6we","large":"style_large__J1ULg","secondary":"style_secondary__i9NHY","badge":"style_badge__1ZLcV"};